import {
  PopupCloseButton,
  PopupWrapper,
} from "../Settings/Sources/SourceRedirectPopup";
import { __, sprintf } from "@wordpress/i18n";
import { useRef, useState } from "react";
import { ReactComponent as Add } from "../assets/add_new.svg";
import { ReactComponent as Loader } from "../assets/loader.svg";
import { ajaxCall } from "../Helpers/AjaxHelper";
import { useDispatch } from "react-redux";
import { setNotificationAction } from "../Helpers/ReduxHelper";

const ImporterPopup = ({ hideCallback }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [importedCount, setImportedCount] = useState(0);
  const dispatch = useDispatch();
  const channelNameRef = useRef();
  const videosCountRef = useRef();

  const recursiveImporter = (
    evt,
    page = 0,
    needed = parseInt(videosCountRef.current.value),
    imported = 0
  ) => {
    setIsLoading(true);
    ajaxCall("sby_do_import_batch", {
      channel: channelNameRef.current.value,
      needed,
      page,
    })
      .then((res) => res.json())
      .then(({ num_retrieved, next }) => {
        const alreadyImported = imported + num_retrieved;
        const nextNeeded = needed - num_retrieved;
        setImportedCount(alreadyImported);

        if (next !== "" && nextNeeded > 0) {
          recursiveImporter(null, next, nextNeeded, alreadyImported);
        } else {
          setIsLoading(false);
          window.location.reload();
        }
      })
      .catch(() => {
        setIsLoading(false);
        dispatch(
          setNotificationAction(
            __("Couldn't find any videos to import.", "feeds-for-youtube"),
            "error"
          )
        );
      });
  };

  return (
    <PopupWrapper step="redirect_1">
      {!isLoading && <PopupCloseButton hideCallback={hideCallback} />}
      <div className="sby-importer-popup flex flex-col self-stretch p-5">
        <h1>{__("Import Videos", "feeds-for-youtube")}</h1>
        <p className="w-11/12">
          {__(
            "Generate WordPress posts from your YouTube channel. Enter the channel name or ID and the number of videos to import below and click “Import”.",
            "feeds-for-youtube"
          )}
        </p>
        <div className="pt-4">
          <label className="flex flex-col self-stretch">
            <span className="sby-importer-label">
              {__("Channel Name or ID", "feeds-for-youtube")}
            </span>
            <input
              ref={channelNameRef}
              type="text"
              className="sby-importer-input"
              placeholder={__(
                "Enter Channel name or ID (for example: voxdotcom)",
                "feeds-for-youtube"
              )}
            />
          </label>
          <label className="flex flex-col self-stretch pt-2">
            <span className="sby-importer-label">
              {__("Number of Videos", "feeds-for-youtube")}
            </span>
            <input
              ref={videosCountRef}
              type="text"
              className="sby-importer-input"
              defaultValue={100}
            />
          </label>
          <button
            onClick={recursiveImporter}
            className={`sb-btn-blue sby-white-icon font-semibold w-full flex flex-row justify-center py-2 mt-4 ${
              isLoading ? "importing" : ""
            }`}
            disabled={isLoading}
          >
            {!isLoading && (
              <>
                <Add className="mr-1.5 mt-1" height="12" />
                <span>{__("Import", "feeds-for-youtube")}</span>
              </>
            )}
            {isLoading && (
              <span className="flex flex-row spac">
                <Loader />
                {sprintf(
                  __("Importing • %s Videos Imported", "feeds-for-youtube"),
                  importedCount
                )}
              </span>
            )}
          </button>
        </div>
      </div>
    </PopupWrapper>
  );
};

export default ImporterPopup;
